/*
 * Global support for getting and setting cookies that expire with the current session
 */
( function() {
	if( typeof window.SYR == 'undefined' ) { window.SYR = {}; }

	window.SYR.SITE_FILTER_COOKIE = 'SiteFilter';
	window.SYR.HOME_PAGE_COOKIE = 'HomePageLink';

	window.SYR.createCookie = function( name, value ) {
		document.cookie = name + '=' + value + '; path=/';
	};

	window.SYR.readCookie = function( name ) {
		var nameEQ = name + '=';
		var ca = document.cookie.split( ';' );
		for( var i = 0; i < ca.length; i++ ) {
			var c = ca[i];
			while( c.charAt( 0 ) == ' ' ) c = c.substring( 1, c.length );
			if( c.indexOf( nameEQ ) == 0 ) return c.substring( nameEQ.length, c.length );
		}
		return null;	
	};
} )();